import React from 'react';
import { Search } from 'lucide-react';

const SearchInput = ({
  disabled = false,
  name = 'search',
  value,
  onChange,
  placeholder = 'Pesquisar...',
  className = '',
}) => {
  return (
    <div className={`relative w-full ${className}`}>
      <input
        type="text"
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        onChange={onChange}
        className="w-full pl-4 pr-8 py-2 rounded-xl bg-white border border-blueSoft placeholder-blueSteel text-base"
      />
      <Search size={20} className="absolute right-2 top-1/2 transform -translate-y-1/2 text-tealMedium" />
    </div>
  );
};

export default SearchInput;
